import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupAction } from '../markup.action';

type IDependencies = IClientApiDependencySegment;

export const bulkRemoveMarkupEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupAction.bulkRemove.started),
  switchMap((params) => {
    return dependencies.api.bulkDeleteMarkups(params).pipe(
      mergeMap(() => [MarkupAction.bulkRemove.done({ params })]),
      catchApiError((error) => [
        MarkupAction.bulkRemove.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
